import { type RouteRecordRaw } from 'vue-router'

export const GalleryRouter: RouteRecordRaw[] = [
  {
    path: '/gallery',
    component: async () => import('./Gallery.vue'),
  },
]
